export default __webpack_public_path__ + "static/media/blog-img214.39d4c1e8.jpg";